import { render, staticRenderFns } from "./DocumentacionImportacionTableFilters.vue?vue&type=template&id=5d2761ec"
import script from "./DocumentacionImportacionTableFilters.vue?vue&type=script&lang=ts"
export * from "./DocumentacionImportacionTableFilters.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports